import { CwDayEnum } from 'src/app/models';
import { POSServiceCalendarSchedule } from '../models/pos-manager.model';
import { ScheduleAdvancedForm } from '../models/service-calendar.model';

export class ScheduleAdvanceConstants {
  static readonly MAX_SCHEDULE_NUMBER = 7 * 2; // 7 days * 2 ranges
  static readonly DEFAULT_TIME = '01:00';
  static readonly DEFAULT_SCHEDULE_ADVANCED_FORM_VALUE: ScheduleAdvancedForm = {
    enabled: false,
    isAllowTwoRange: false,
    first_range: {
      id: undefined,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME
    },
    second_range: {
      id: undefined,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME
    }
  };
  // Day values use cwday (ISO 8601): Monday=1 ... Sunday=7
  static readonly DEFAULT_SCHEDULES: POSServiceCalendarSchedule[] = [
    {
      day: CwDayEnum.Monday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Monday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Tuesday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Tuesday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Wednesday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Wednesday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Thursday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Thursday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Friday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Friday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Saturday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Saturday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    },
    {
      day: CwDayEnum.Sunday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 0
    },
    {
      day: CwDayEnum.Sunday,
      enable: false,
      start_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      end_time: ScheduleAdvanceConstants.DEFAULT_TIME,
      sort_order: 1
    }
  ];
}
